// extracted by mini-css-extract-plugin
module.exports = {"total-income-label":"_2FNmE0fi3gejk7_3v_kfpJ","total-income-detail":"_3LXBfrdnz46TOr3xvxJEEx","total-income-amount":"jsURxeBxSBDN-vnBbUrQB"};